import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './Button.css';

interface ButtonProps {
    children: React.ReactNode;
    onClick: () => void;
    variant?: 'primary' | 'secondary';
    icon?: IconDefinition;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = ({
    children,
    onClick,
    variant = 'primary',
    icon,
    disabled = false,
    type = 'button'
}) => {
    return (
        <button
            type={type}
            className={`registros-button registros-button--${variant}`}
            onClick={onClick}
            disabled={disabled}
        >
            <div className="registros-button__text">
                {icon && <FontAwesomeIcon icon={icon} className="registros-button__icon" />}
                {children}
            </div>
        </button>
    );
};

export default Button;
